import { Moment } from 'moment';

export const getMonth = (value: Moment) => value!.format('MMMM');

export const getYear = (value: Moment) => value!.format('YYYY');

export const getPrevMonth = (value: Moment) =>
  value!.clone().subtract(1, 'month');

export const getNextMonth = (value: Moment) => value!.clone().add(1, 'month');
